// extracted by css-extract-rspack-plugin
export default {"profile":"gnk47","avatar_override":"l1oRd","avatarOverride":"l1oRd","#":"KvRMb"};